import classNames from 'classnames'
import * as ButtonStyles from '../../styles/v1/button.module.scss'
import * as ContactStyles from '../../styles/v1/contact.module.scss'
import * as StandardStyles from '../../styles/v1/standard.module.scss'
import * as UtilsStyles from '../../styles/v1/utils.module.scss'

const ContactBanner = () => {
  return (
    <section className={classNames(ContactStyles.productContact)} id="contact">
      <div className={ContactStyles.productContact_Content}>
        <h3
          className={classNames(
            ContactStyles.productContact_Headline,
            StandardStyles.abstractStandard_Headline,
            'trackScroll'
          )}
        >
          一人ひとりに合わせた
          <br />
          体験づくりをはじめましょう
        </h3>
        <p className={classNames(ContactStyles.productContact_Lead, 'js-contact-lead')}>
          お気軽にご質問・ご相談ください。
          <br className={UtilsStyles.isPc} />
          担当からすぐにご連絡いたします。
        </p>
        <ul className={ContactStyles.productContact_ButtonOuter}>
          <li className={ContactStyles.productContact_Item}>
            <a
              className={classNames(
                ButtonStyles.abstractButton,
                ButtonStyles.abstractButtonLarge,
                ContactStyles.productContact_Button,
                'trackBtn',
                'js-contact-button'
              )}
              href="https://karte.io/enterprise/"
              target="_blank"
              data-category="body"
              data-action="cv"
              data-label="お問い合わせ"
              rel="noreferrer"
            >
              お問い合わせ
            </a>
          </li>
          <li />
        </ul>
      </div>
      <picture>
        <source media="(min-width: 768px)" srcSet="https://karte.io/assets/images/common/product/banner_contact.png" />
        <source
          media="(max-width: 767px)"
          srcSet="https://karte.io/assets/images/common/product/banner_contact_mobile.png"
        />
        <img
          className={ContactStyles.productContact_Banner}
          src="/assets/images/common/product/banner_contact.png"
          alt="お問い合わせバナー"
          loading="lazy"
        />
      </picture>
    </section>
  )
}

export default ContactBanner
